<template>
  <div class="container">
    <!-- 展示图书列表 -->
    <a-list item-layout="vertical" size="large" :grid="{ gutter: 20, column: 3 }"
      :data-source="data"><!-- 显示分页:pagination="pagination" -->
      <template #renderItem="{ item }">
        <router-link :to="'/step?trackId=' + item.id" slots="a" target="_blank">
          <a-card style="height: 200px;margin: 5px;" :bordered="true" :hoverable="true" class="card">
            <a-list-item key="item.title">
              <template #actions>
                <!-- 步骤数量 -->
                <span>
                  <component v-bind:is="'TagsOutlined'" style="margin-right: 8px" />
                  步骤 {{ item.stepCount }}
                </span>
                <!-- 课程数量 -->
                <span>
                  <component v-bind:is="'FileOutlined'" style="margin-right: 8px" />
                  课程 {{ item.ebookCount }}
                </span>
                <!-- 阅读 -->
                <!-- <span>
                    <component v-bind:is="'UserOutlined'" style="margin-right: 8px" />
                    阅读 {{ item.viewCount }}
                  </span> -->
                <!-- 点赞数 -->
                <span>
                  <component v-bind:is="'LikeOutlined'" style="margin-right: 8px" />
                  点赞 {{ item.voteCount }}
                </span>
              </template>
              <!-- :description="item.description"-->
              <a-list-item-meta>
                <template #title>
                  <!-- <a :href="item.href">{{ item.name }}</a> -->
                  <!-- 修改成页面路由 -->
                  <router-link :to="'/step?trackId=' + item.id" slots="a" target="_blank">
                    {{ item.name }}
                  </router-link>
                </template>
                <!-- 左侧图片 -->
                <template #avatar>
                  <a-avatar :src="item.coverUrl" />
                </template>
                <!-- 描述  -->
                <template #description>
                  <span class="description"> {{ item.description }}</span>
                </template>
              </a-list-item-meta>
              <!--{{ item.content }}-->
            </a-list-item>
          </a-card>
        </router-link>
      </template>
    </a-list>

  </div>
</template>

<script lang="ts">
import { defineComponent, defineProps, ref, onMounted, watch } from 'vue'

// 卡片图书组件
export default defineComponent({
  name: 'TheTracksCard',
  props: {
    // 组件传入的数据
    data: {

    }
  },

  setup(props) {

    // let tracks: any = ref([]);

    // 监听data变化
    watch(() => props.data, async (newData, oldData) => {
      console.log('watch', newData, oldData)
      // tracks.value = newData
    })

    onMounted(() => {
      // console.log('data -------' + props.data + '----------')
    });

    return {
      // tracks
    }
  }
});
</script>
<style scoped>
.container {
  /* background: #F2F4F6;
  padding: 0px; */
}

/*电子书图标形状*/
.ant-avatar {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 1%;
  margin: 0px 0;
}

/* 限定描述 3 行 */
.description {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
